$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
ApiPromise = require 'app/scripts/network/api-promise'
Auth = require 'app/scripts/db/auth'
Board = require 'app/scripts/models/board'
{ boxClientId, dropboxClientAppKey, oneDriveClientId } = require '@trello/config'
Card = require 'app/scripts/models/card'
GoogleApi = require 'app/scripts/lib/google-api'
LimitExceeded = require 'app/scripts/views/attachment/attachment-limit-exceeded-error'
TypeRestricted = require 'app/scripts/views/attachment/attachment-type-restricted-error'
limitExceededTemplate = require 'app/scripts/views/templates/popover_limit_exceeded'
{ isSubmitEvent } = require '@trello/keybindings'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
Storage = require 'app/scripts/lib/storage'
TrelloCompleterView = require 'app/scripts/views/internal/autocomplete/trello-completer-view'
UploadingLinkView = require 'app/scripts/views/card/uploading-link-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
t = require('app/scripts/views/internal/teacup-with-helpers')('attachment_type_picker')
{ track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
ninvoke = require 'app/scripts/lib/util/ninvoke'
f = require 'effing'
customError = require '@atlassian/trello-error-ext'
pastedFileName = require 'app/scripts/views/internal/pasted-file-name'
parseTrelloUrl = require 'app/scripts/lib/util/url/parse-trello-url'
{ dontUpsell } = require '@trello/config'
Tooltip = require 'app/scripts/views/lib/tooltip'

FileTooLarge = customError('AttachmentTypePickerView::FileTooLarge')

template = t.renderable ({ hasLargeAttachments, id, googleDriveReady, tipKey, tipData, defaultName, restrictedAttachmentTypes }) ->
  tipKey ?= 'tip-you-can-drag-and-drop-files-and-links-onto-cards-to-upload-them'
  tipData ?= {}

  t.div '.error.js-file-too-large', { style: 'margin: 12px 0 6px; display:none;' }, ->
    if hasLargeAttachments
      t.format 'that-file-size-exceeds-the-250mb-limit'
    else
      if !dontUpsell
        t.div '.gold-promo', ->
          t.format 'that-file-size-exceeds-the-10mb-limit-but-if-you-upgrade-to'
          t.icon 'trello-gold', 'trello-gold-you-can-upload-files-up-to-250mb'
          return
      else
        t.div '.gold-promo', ->
          t.format 'that-file-size-exceeds-the-10mb-limit'
          return
    return

  t.ul '.pop-over-list', ->
    if 'computer' in restrictedAttachmentTypes
      t.li ->
        t.a '.disabled.js-attachment-restricted', { href: '#' }, ->
          t.format 'computer'
    else
      t.li '.uploader', ->
        t.a '.fakefile', { href: '#' }, ->
          t.format 'computer'
        t.form '.realfile', { action: '/1/card/' + id + '/attachments', method: 'post', enctype: 'multipart/form-data' }, ->
          t.input { type: 'hidden', name: 'token', value: '' }
          t.input { type: 'hidden', name: 'format', value: 'http' }
          t.input '.js-attach-file', { type: 'file', name: 'file', tabindex: '-1', multiple: '' }

    t.li ->
      t.a '.js-attach-card', { href: '#' }, ->
        t.format 'trello'

      t.li ->
        t.a '.js-google-drive-attachment', { href: '#', class: t.classify({
          'disabled': !googleDriveReady || 'google-drive' in restrictedAttachmentTypes,
          'js-attachment-restricted': 'google-drive' in restrictedAttachmentTypes
        }) }, ->
          t.format 'google-drive'

      t.li ->
        t.a '.js-dropbox-attachment', { href: '#', class: t.classify({
          'disabled js-attachment-restricted': 'dropbox' in restrictedAttachmentTypes
        }) }, ->
          t.format 'dropbox'

      t.li ->
        t.a '.js-box-attachment', { href: '#', class: t.classify({
          'disabled js-attachment-restricted': 'box' in restrictedAttachmentTypes
        }) }, ->
          t.format 'box'

      t.li ->
        t.a '.js-one-drive-attachment', { href: '#', class: t.classify({
          'disabled js-attachment-restricted': 'onedrive' in restrictedAttachmentTypes
        }) }, ->
          t.format 'onedrive'

    return

  t.hr()

  if 'link' in restrictedAttachmentTypes
    t.ul '.pop-over-list', ->
      t.li ->
        t.a '.disabled.js-attachment-restricted', ->
          t.format 'attach-a-link'
  else
    t.label { for: 'addLink' }, ->
      t.format 'attach-a-link'
      return

    t.input '.attachment-add-link-input.js-attachment-url.js-autofocus', { type: 'text', id: 'addLink', placeholder: t.l('paste-any-link-here-ellipsis') }

    t.div '.js-name-link.hide', ->
      t.label { for: 'nameLink' }, ->
        t.format 'link-name'
        return

      t.input '.attachment-add-link-input.js-attachment-name', { type: 'text', id: 'nameLink', value: defaultName }

    t.input '.js-add-attachment-url', { style: 'margin: 0;', type: 'submit', value: t.l('attach') }

  t.hr()

  t.p '.quiet.u-bottom', ->
    t.format tipKey, tipData
    return

  return

module.exports = class AttachmentTypePickerView extends View
  viewTitleKey: 'attach from'

  initialize: ->
    @listenTo(GoogleApi, 'loaded', @render)

  events:
    'click .js-google-drive-attachment:not(.disabled)':
      'openGoogleDriveFilePicker'
    'click .js-dropbox-attachment': 'openDropboxFilePicker'
    'click .js-one-drive-attachment': 'openOneDriveFilePicker'
    'click .js-box-attachment': 'openBoxFilePicker'
    'click .js-attach-card': 'attachCard'
    'change .js-attach-file': 'startUpload'
    'click .js-add-attachment-url': 'addUrl'
    'keydown .js-attachment-url': 'keydown'
    'keydown .js-attachment-name': 'keydown'
    'input .js-attachment-url': 'toggleAttachmentNameInput'
    'mouseenter .js-attachment-restricted': 'showRestrictedTooltip'
    'mouseleave .js-attachment-restricted': 'hideRestrictedTooltip'
    'click a[href^="/gold"]': ->
      track("Attachment", "Open Trello Gold Promo - via Attachment Upload Limit")
    'click a[href^="/business-class"]': ->
      track("Card Detail", "Attachments BC Ad")

  _scripts:
    dropbox: 'https://www.dropbox.com/static/api/1/dropbox.js'
    box: 'https://app.box.com/js/static/select.js'
    oneDrive: 'https://js.live.net/v7.0/OneDrive.js'

  getCard: ->
    if @model instanceof Card
      @model
    else
      @model.getCard()

  getData: ->
    # We're trying to delay loading these scripts, to reduce the chance that
    # they'll cause problems on the client; unfortunately we need to load them
    # prior to the user trying to upload a file from that service, otherwise
    # any popup windows they try to open will be blocked (i.e. if we try to
    # asynchronously load a script between the time they click and when we start
    # the associated picker)
    for key, scriptUrl of @_scripts
      @_loadOnce scriptUrl, (->)
    return

  render: ->
    if !@getCard().canAttach()
      if @getCard().isOverLimit('attachments', 'perCard')
        @$el.html(limitExceededTemplate('perCard'))
      else if @getCard().getBoard().isOverLimit('attachments', 'perBoard')
        @$el.html(limitExceededTemplate('perBoard'))
      return @

    org = @getCard().getBoard()?.getOrganization()
    data =
      id: @getCard().id
      hasLargeAttachments: Auth.me()?.isFeatureEnabled('largeAttachments') || org?.isFeatureEnabled('largeAttachments')
      googleDriveReady: GoogleApi.loaded
      defaultName: @options.defaultName
      restrictedAttachmentTypes: org?.getRestrictedAttachmentTypes() || []

    # Everyone can turn on power-ups now
    if !(org? && org.isFeatureEnabled('plugins'))
      data.tipKey = 'tip-you-can-attach-other-things-with-power-ups'
      data.tipData =
        url: '/power-ups?utm_source=trello&utm_medium=inapp&utm_content=attachments-menu&utm_campaign=power-ups'

    @$el.html(template(data))

    @

  startUpload: (e) ->
    $input = $(e.target)
    $tooLarge = @$('.js-file-too-large').hide()
    files = _.toArray($input[0].files)
    options = @options

    if options.onStartUpload
      options.onStartUpload()

    upload = if files.length > 0
      if _.any(files, (file) -> !Auth.me().canUploadAttachment(file))
        Promise.reject FileTooLarge()
      else
        Promise.resolve files
        .each (file) =>
          # There may be an @options.defaultName, but we don't want to use
          # it because we want to keep the file extension
          name = file.name || pastedFileName()
          ninvoke @getCard(), 'upload', file, name
          .then (response) =>
            @trigger "attach",
              mimeType: response.mimeType
              name: @options.defaultName || name
              url: response.url
    else
      # Doesn't support the file API, use form based upload
      ninvoke Util, 'uploadFile', Auth.myToken(), $input

    upload.then ->
      track("Card Detail", "Upload Attachment Complete - Via Picker")
      Alerts.show('finished uploading', 'info', 'AjaxQueueUpload', 2000)
      PopOver.hide()
      if options.onFinishUpload
        options.onFinishUpload()
    .catch FileTooLarge, ->
      $tooLarge.show()
      track("Card Detail", "Attachment", "Upload Error - File Too Large")
    .catch LimitExceeded, =>
      @render()
      track("Card Detail", "Attachment", "Upload Error - Limit Exceeded")
    .done()

  _loadOnce: (scriptUrl, next) ->
    window._loadedScripts ?= {}
    if window._loadedScripts[scriptUrl]
      return next()

    $.getScript scriptUrl, =>
      window._loadedScripts[scriptUrl] = true
      next()

  attachLinks: (type, objs, normalize) ->
    if !objs
      return
    @$('.js-limit-exceeded').toggleClass('hide', true)
    @options.onStartUpload && @options.onStartUpload(@model, type)

    PopOver.pushView
      view: UploadingLinkView
    Promise.resolve(objs)
    .call 'map', normalize ? (o) -> o
    .each (file) =>
      data = _.pick(file, 'url', 'mimeType', 'name')
      @trigger 'attach', data
      Promise.fromNode (next) => @getCard().uploadUrl(data, next)
      .then (response) =>
        track("Card Detail", "Upload #{type}")
    .then =>
      PopOver.hide()
    .catch LimitExceeded, =>
      PopOver.popView() # Pop the `UploadingLinkView`
      @render() # Re-render to show the limit exceeded error
      track("Card Detail", "Attachment", "Upload Error - Limit Exceeded")
    .catch TypeRestricted, =>
      Alerts.show('link type restricted', 'error', 'attachment', 5000)
      PopOver.hide()
    .finally =>
      @options.onFinishUpload && @options.onFinishUpload(@model, type)
    .done()

  openGoogleDriveFilePicker: (e) ->
    Util.stop(e)

    ninvoke gapi, 'load', 'picker'
    .then ->
      # If we received an oauth token in the past, we can do a background
      # request to refresh it, since it will not spawn a popup window.
      refresh = GoogleApi.validToken()
      ninvoke GoogleApi, 'authorize', refresh
    .then (oauthToken) =>
      # Use a docs view that shows folders
      docsView = new google.picker.DocsView()
      docsView.setIncludeFolders(true)

      teamDrivesView = new google.picker.DocsView()
      teamDrivesView.setIncludeFolders(true)
      teamDrivesView.setSelectFolderEnabled(true)
      teamDrivesView.setEnableTeamDrives(true)

      picker = new google.picker.PickerBuilder()
      .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
      .enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
      .addView(docsView)
      .addView(teamDrivesView)
      .setOAuthToken(oauthToken)
      .setCallback (data) =>
        @attachLinks 'Google drive file', data.docs, f.id
      .build()

      picker.setVisible(true)
      # Fix ridiculous google drive bug
      $('iframe.picker-frame[src*=authserviceid]').attr('src', (-> $(@).attr('src').replace(/authserviceid/g, 'fixgoogle')))
    .done()

  openDropboxFilePicker: (e) ->
    Util.stop(e)

    @_loadOnce @_scripts.dropbox, =>
      Dropbox.init({ appKey: dropboxClientAppKey })
      Dropbox.choose
        linkType: 'preview'
        iframe: true
        success: (files) =>
          @attachLinks 'Dropbox file', files, (file) ->
            url: file.link
            name: file.name

      # The overlay that dropbox creates isn't scrollable, so if your window
      # isn't very tall you can't click the cancel button.  This hack fixes
      # this situation by finding the chooser iframe and making the parent
      # scrollable
      $('iframe[src^="https://www.dropbox.com/chooser"]')
      .parent()
      .css('overflow', 'auto')
      return
    return

  openOneDriveFilePicker: (e) ->
    Util.stop(e)

    @_loadOnce @_scripts.oneDrive, =>
      Promise.try ->
        new Promise (resolve, reject) ->
          OneDrive = window.OneDrive
          OneDrive.open({
            clientId: oneDriveClientId
            action: 'share'
            multiSelect: true
            # If this is false, it takes over the whole window … not an overlay
            openInNewWindow: true
            success: (response) ->
              resolve(response.value)
            cancel: -> resolve([])
            error: (e) -> reject(e)
            advanced:
              redirectUri: "#{ siteDomain }/onedrive_callback_7.html"
          })
      .then (files) =>
        @attachLinks 'OneDrive file', files, (file) ->
          url: file.webUrl
          name: file.name
      .done()

      return
    return


  openBoxFilePicker: (e) ->
    Util.stop(e)

    @_loadOnce @_scripts.box, =>
      boxSelect = new BoxSelect
        clientId: boxClientId
        linkType: 'shared'
        multiselect: true

      boxSuccess = (files) =>
        boxSelect.unregister(boxSelect.SUCCESS_EVENT_TYPE, boxSuccess)
        @attachLinks 'Box file', files, f.id

      boxSelect.success(boxSuccess)

      boxSelect.launchPopup()

  keydown: (e) ->
    if isSubmitEvent(e)
      @addUrl()

  addUrl: (e) ->
    urls = @$('.js-attachment-url').val().split(/\s+/)
    name = @$('.js-attachment-name').val()
    if !/\S/.test(name)
      name = undefined

    urls = _.filter urls, (url) ->
      /\S/.test(url)

    if !_.isEmpty(urls) && urls.length < 10
      @attachLinks 'link', urls, (url) -> { url, name }
    return

  attachCard: (e) ->
    trelloCompleterView = new TrelloCompleterView
      model: @model
      card: @model
      modelCache: @modelCache
      button: true
      onStartUpload: (item) =>
        if item instanceof Card
          url = item.get('url')
          @attachLinks 'card', [{ url }]
        else if item instanceof Board
          url = item.get('url')
          @attachLinks 'board', [{ url }]

    PopOver.pushView
      view: trelloCompleterView

  toggleAttachmentNameInput: (e) ->
    url = $(e.currentTarget).val()
    { type } = parseTrelloUrl(url)
    isTrelloAttachment = type in ['board', 'card']
    isEmpty = !/\S/.test(url)
    @$('.js-name-link').toggleClass('hide', isTrelloAttachment or isEmpty)

  showRestrictedTooltip: (e) ->
    $el = @$(e.target)
    Tooltip.show(t.l('attachment-type-restricted'), $el, false, Tooltip.STYLE.MENU)

  hideRestrictedTooltip: ->
    Tooltip.hide()
